import React from "react";

const Button = ({ text, notFullWidth, className, ...others }) => {
  return (
    <button
      {...others}
      className={`px-6 py-2 bg-white hover:bg-gray-200 text-gray-900 border-2 border-transparent focus:border-blue-500 text-sm rounded ${className} ${notFullWidth ? 'w-fit':'w-full'} `}
    >
      {text}
    </button>
  );
};

export default Button;
